import { useEffect } from 'react';

import { AvtaleGiroActionType } from '../../components/transaction/AvtaleGiro/form/actions';
import useFormContext from '../../components/transaction/AvtaleGiro/form/useFormContext';
import useAmount from '../../hooks/queryparams/useAmount';
import useQueryParam from '../../hooks/queryparams/useQueryParam';
import useReceiverAccount from '../../hooks/useReceiverAccount';

export default () => {
    const { handleChange } = useFormContext();
    const amount = useAmount();
    const receiver = useReceiverAccount();
    const kid = useQueryParam('kid');

    useEffect(() => {
        if (amount) {
            handleChange({ type: AvtaleGiroActionType.TRANSACTION_AMOUNT_LIMIT, payload: amount });
        }
    }, [handleChange, amount]);
    useEffect(() => {
        if (kid) {
            handleChange({ type: AvtaleGiroActionType.SET_KID, payload: { value: kid } });
        }
    }, [handleChange, kid]);
    useEffect(() => {
        if (receiver) {
            handleChange({ type: AvtaleGiroActionType.TO_ACCOUNT_SELECTED, payload: receiver });
        }
    }, [handleChange, receiver]);

    return { receiver, kid };
};
